import React from "react";
import {
  Box,
  Button,
  DialogActions,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Close, FilterList, Clear } from "@mui/icons-material";
import { alpha, useTheme } from "@mui/material/styles";

export const filterModalPaperProps = (theme) => ({
  sx: {
    maxHeight: "90vh",
    borderRadius: 3,
    overflow: "hidden",
    boxShadow: theme.shadows[8],
  },
});

export const filterModalContentSx = (theme) => ({
  p: 3,
  backgroundColor: theme.palette.background.alt,
  display: "flex",
  flexDirection: "column",
  gap: 3,
});

export const FilterModalHeader = ({ title, onClose }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.common.white,
        p: 2.5,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Stack direction="row" alignItems="center" gap={1.5} minWidth={0}>
          <Box
            sx={{
              backgroundColor: alpha(theme.palette.common.white, 0.14),
              borderRadius: 2,
              p: 0.75,
              display: "flex",
              flexShrink: 0,
            }}
          >
            <FilterList sx={{ fontSize: 24 }} />
          </Box>
          <Typography variant="h6" fontWeight={700} noWrap>
            {title}
          </Typography>
        </Stack>
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="Tutup filter"
          sx={{
            color: theme.palette.common.white,
            backgroundColor: alpha(theme.palette.common.white, 0.1),
            flexShrink: 0,
            "&:hover": {
              backgroundColor: alpha(theme.palette.common.white, 0.2),
            },
          }}
        >
          <Close />
        </IconButton>
      </Stack>
    </Box>
  );
};

export const FilterModalActions = ({
  onClearFilter,
  onClose,
  onApply,
  activeCount = 0,
}) => {
  const theme = useTheme();

  return (
    <DialogActions
      sx={{
        p: 2.5,
        justifyContent: "space-between",
        gap: 2,
        backgroundColor: theme.palette.background.alt,
        borderTop: `1px solid ${theme.palette.divider}`,
        flexWrap: "wrap",
      }}
    >
      <Button
        onClick={onClearFilter}
        startIcon={<Clear />}
        variant="outlined"
        color="inherit"
        sx={{
          borderColor: theme.palette.divider,
          color: theme.palette.text.secondary,
          borderRadius: 1.5,
          textTransform: "none",
          "&:hover": {
            borderColor: theme.palette.secondary.main,
            color: theme.palette.secondary.main,
          },
        }}
      >
        Reset Filter
      </Button>
      <Stack direction="row" gap={1.5}>
        <Button onClick={onClose} variant="text" color="inherit" sx={{ textTransform: "none" }}>
          Batal
        </Button>
        <Button
          onClick={onApply}
          variant="contained"
          color="secondary"
          startIcon={<FilterList />}
          sx={{ borderRadius: 1.5, textTransform: "none", fontWeight: 700 }}
        >
          Terapkan {activeCount > 0 && `(${activeCount})`}
        </Button>
      </Stack>
    </DialogActions>
  );
};
